<template>
    <NavBar v-if="!isMobile()" ></NavBar>
    <NavBarmob v-if="isMobile()"></NavBarmob>
    <header  class="page-header" >
    <div class="container">
    </div>
    </header>
      <!-- <Bannerab></Bannerab> -->
    
    <main>
        <section class="content-section contpadd">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="section-title text-center xsmar2">
            <!-- 		  <h6>CONNECT WITH US</h6> -->
            <h2 style="text-align: left">Help Centre</h2>
          </div>
          <!-- end section-title -->
        </div>
        <!-- end col-12 -->
        <div class="col-lg-12">
          <p>
            HiLITE Group Of Companies, one of the most trusted names in South
            India, is synonymous with innovation and authenticity. A few of the
            company’s best projects include Focus Mall, Kerala's first shopping
            mall, HiLITE Mall, one of the largest malls in Kerala, HiLITE City,
            one of India's biggest mixed-use developments, HiLITE Business Park,
            a futuristic office space center and numerous premium residential
            projects. The company that started two decades ago has now
            diversified into multiple group companies, their newest venture
            being Palaxi Cinemas. Palaxi Cinemas are a chain of world-class
            theatres that aim to upgrade the experience of movie-watching. With
            the latest technology in the field of cinema, Palaxi is all set to
            breathe life into futuristic theatres.
          </p>
          <!-- end contact-box -->
        </div>
        <!-- end col-4 -->

        <!-- end col-4 -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </section>
      <Footers v-if="!isMobile()"></Footers>
      <Footermob v-if="isMobile()"></Footermob>
    </main>
   
   
  </template>
  
  <script>
  // import Bannerab from "./AboutUsBanner.vue";
  import NavBar from "../UI/NavBar.vue";
  import Footers from "../UI/SiteFooter.vue";
  import NavBarmob from "../UI/NavBarmob.vue";
  import Footermob from "../Indexmobile/IndexFooter.vue";
  export default {
    components:{
      // Bannerab,
      NavBar,
      NavBarmob,
      Footermob,
      Footers
    },
    methods:{
      isMobile() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      },
    },
    mounted:async function(){
      var mastHeight=document.querySelector('.page-header, .slider').clientHeight;
      document.querySelector('main').style.marginTop=mastHeight+"px";
    }
  
  };
  
  </script>
  